import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-022fe466"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "QuotedPrice" }
const _hoisted_2 = { class: "bg" }
const _hoisted_3 = {
  key: 0,
  class: "userWarpper"
}
const _hoisted_4 = { class: "sellerUser" }
const _hoisted_5 = { class: "user" }
const _hoisted_6 = { class: "info" }
const _hoisted_7 = { class: "nickName" }
const _hoisted_8 = { class: "recent" }
const _hoisted_9 = { class: "current" }
const _hoisted_10 = { class: "productInfo" }
const _hoisted_11 = { class: "address" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "用苗地区：", -1))
const _hoisted_13 = { class: "tips" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "其它说明：", -1))
const _hoisted_15 = { class: "from" }
const _hoisted_16 = { class: "warpper" }
const _hoisted_17 = { class: "pricetype" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "价格类型:", -1))
const _hoisted_19 = { class: "right" }
const _hoisted_20 = /*#__PURE__*/_createTextVNode("上车价")
const _hoisted_21 = /*#__PURE__*/_createTextVNode("地苗价")
const _hoisted_22 = { class: "upload" }
const _hoisted_23 = { class: "uploadWarpper" }
const _hoisted_24 = ["onClick"]
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tips" }, "如上传图片报价，您的报价信息将优先通知给求购者", -1))
const _hoisted_26 = { class: "upload" }
const _hoisted_27 = { class: "uploadWarpper" }
const _hoisted_28 = {
  key: 0,
  class: "imgItem"
}
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tips" }, "如上传图片视频，您的报价信息将排序优先", -1))
const _hoisted_30 = { class: "upload" }
const _hoisted_31 = { class: "actions" }
const _hoisted_32 = /*#__PURE__*/_createTextVNode("提交报价")
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "发布过的类似供应", -1))
const _hoisted_34 = { class: "list" }
const _hoisted_35 = { class: "info" }
const _hoisted_36 = { class: "name" }
const _hoisted_37 = { class: "tips" }
const _hoisted_38 = { class: "action" }
const _hoisted_39 = /*#__PURE__*/_createTextVNode("选择")
const _hoisted_40 = { class: "logo" }
const _hoisted_41 = { class: "content" }
const _hoisted_42 = { class: "btn" }
const _hoisted_43 = /*#__PURE__*/_createTextVNode("确定")
const _hoisted_44 = /*#__PURE__*/_createTextVNode("重新提交")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VanImage = _resolveComponent("VanImage")!
  const _component_VanRadio = _resolveComponent("VanRadio")!
  const _component_VanRadioGroup = _resolveComponent("VanRadioGroup")!
  const _component_VanField = _resolveComponent("VanField")!
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_VanUploader = _resolveComponent("VanUploader")!
  const _component_van_field = _resolveComponent("van-field")!
  const _component_VanButton = _resolveComponent("VanButton")!
  const _component_VanPopup = _resolveComponent("VanPopup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (Object.keys($setup.detail).length != 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_VanImage, {
                  src: $setup.detail.information.avatarUrl,
                  width: "3rem"
                }, null, 8, ["src"]),
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, _toDisplayString($setup.detail.information.nickName), 1),
                  _createElementVNode("div", _hoisted_8, "最近发布" + _toDisplayString($setup.detail.information.purchases) + "条求购", 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_9, "正在采购：" + _toDisplayString($setup.detail.title), 1)
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _hoisted_12,
                _createTextVNode(_toDisplayString($setup.detail.receiptAddress), 1)
              ]),
              _createElementVNode("div", _hoisted_13, [
                _hoisted_14,
                _createTextVNode(_toDisplayString($setup.detail.profile), 1)
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_15, [
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("div", _hoisted_17, [
          _hoisted_18,
          _createElementVNode("div", _hoisted_19, [
            _createVNode(_component_VanRadioGroup, {
              modelValue: $setup.radio,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.radio) = $event))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_VanRadio, {
                  "checked-color": "#07c160",
                  name: false,
                  onClick: $setup.clickmethod
                }, {
                  default: _withCtx(() => [
                    _hoisted_20
                  ]),
                  _: 1
                }),
                _createVNode(_component_VanRadio, {
                  "checked-color": "#07c160",
                  name: true,
                  onClick: $setup.clickmethod
                }, {
                  default: _withCtx(() => [
                    _hoisted_21
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"])
          ])
        ]),
        _createVNode(_component_VanField, {
          class: "fieldInput price cell",
          label: "我的报价：",
          type: "number",
          modelValue: $setup.submitdata.price,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.submitdata.price) = $event)),
          required: "",
          placeholder: "请输入价格",
          "input-align": "right",
          border: false
        }, {
          button: _withCtx(() => [
            _createTextVNode("元/" + _toDisplayString($setup.detail.unit), 1)
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createVNode(_component_VanField, {
          class: "cell",
          label: "发货地区：",
          readonly: "",
          "model-value": $setup.addressName || `请选择地址`,
          required: "",
          onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.isShowCityPicker = true)),
          "input-align": "right",
          border: false
        }, null, 8, ["model-value"])
      ]),
      _createElementVNode("div", _hoisted_22, [
        _createElementVNode("div", _hoisted_23, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.imgList, (item, idx) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "imgItem",
              key: `img${idx}`
            }, [
              _createVNode(_component_VanImage, {
                src: item.img,
                style: {"width":"100%","height":"100%"}
              }, null, 8, ["src"]),
              _createElementVNode("div", {
                class: "close",
                onClick: ($event: any) => ($setup.closeImg(idx))
              }, [
                _createVNode(_component_van_icon, {
                  name: "cross",
                  color: "white"
                })
              ], 8, _hoisted_24)
            ]))
          }), 128)),
          _withDirectives(_createVNode($setup["UpLoad"], {
            multiple: "",
            "after-read": $setup.afterRead,
            accept: "image/*",
            "max-count": "9"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_VanImage, {
                src: require("@/assets/img/uploadImage.png"),
                style: {"width":"80px","height":"80px"}
              }, null, 8, ["src"])
            ]),
            _: 1
          }, 512), [
            [_vShow, $setup.imgList.length <= 9]
          ])
        ]),
        _hoisted_25
      ]),
      _createElementVNode("div", _hoisted_26, [
        _createElementVNode("div", _hoisted_27, [
          (Object.keys($setup.videoImg).length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                _createVNode(_component_VanImage, {
                  src: $setup.videoImg.img,
                  style: {"width":"100%","height":"100%"}
                }, null, 8, ["src"]),
                _createElementVNode("div", {
                  class: "close",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => {$setup.videoImg="";$setup.submitdata.video=[]})
                }, [
                  _createVNode(_component_van_icon, {
                    name: "cross",
                    color: "white"
                  })
                ])
              ]))
            : (_openBlock(), _createBlock(_component_VanUploader, {
                key: 1,
                "after-read": $setup.videoAfterRead,
                accept: "video/*",
                "max-count": "1"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_VanImage, {
                    src: require("@/assets/img/uploadVideo.png"),
                    style: {"width":"80px","height":"80px"}
                  }, null, 8, ["src"])
                ]),
                _: 1
              }))
        ]),
        _hoisted_29
      ]),
      _createElementVNode("div", _hoisted_30, [
        _createVNode(_component_van_field, {
          class: "textarea",
          modelValue: $setup.submitdata.profile,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.submitdata.profile) = $event)),
          rows: "3",
          autosize: "",
          type: "textarea",
          maxlength: "50",
          placeholder: "备注说明",
          "show-word-limit": ""
        }, null, 8, ["modelValue"])
      ])
    ]),
    _createVNode($setup["CityPicker"], {
      modelValue: $setup.isShowCityPicker,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($setup.isShowCityPicker) = $event)),
      onConfirm: $setup.confirm
    }, null, 8, ["modelValue"]),
    _createElementVNode("div", _hoisted_31, [
      _createVNode(_component_VanButton, {
        block: "",
        color: "#fec64b",
        onClick: $setup.submit
      }, {
        default: _withCtx(() => [
          _hoisted_32
        ]),
        _: 1
      })
    ]),
    _createVNode($setup["DataDoesNotExist"], {
      modelValue: $setup.isDataExist,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($setup.isDataExist) = $event))
    }, null, 8, ["modelValue"]),
    _createVNode(_component_VanPopup, {
      class: "supplyDialog",
      show: $setup.isShowList,
      "onUpdate:show": _cache[7] || (_cache[7] = ($event: any) => (($setup.isShowList) = $event)),
      position: "bottom"
    }, {
      default: _withCtx(() => [
        _hoisted_33,
        _createElementVNode("div", _hoisted_34, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.list, (item, idx) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "listItem",
              key: `supply${idx}`
            }, [
              _createElementVNode("div", _hoisted_35, [
                _createElementVNode("div", _hoisted_36, [
                  _createTextVNode(_toDisplayString(item.title) + " ", 1),
                  _createElementVNode("span", null, _toDisplayString(item.quantity) + _toDisplayString(item.unit), 1)
                ]),
                _createElementVNode("div", _hoisted_37, _toDisplayString(item.address), 1)
              ]),
              _createElementVNode("div", _hoisted_38, [
                _createVNode(_component_VanButton, {
                  size: "small",
                  color: "#ffcc32",
                  onClick: ($event: any) => ($setup.selectSupply(item))
                }, {
                  default: _withCtx(() => [
                    _hoisted_39
                  ]),
                  _: 2
                }, 1032, ["onClick"])
              ])
            ]))
          }), 128))
        ])
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(_component_VanPopup, {
      class: "resultDialog",
      show: $setup.isShowResult,
      "onUpdate:show": _cache[8] || (_cache[8] = ($event: any) => (($setup.isShowResult) = $event)),
      position: "center"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_40, [
          _createVNode(_component_VanImage, {
            src: $setup.resultstatus ?require("@/assets/img/success.png"):require("@/assets/img/fail.png"),
            width: "65",
            height: "72"
          }, null, 8, ["src"])
        ]),
        _createElementVNode("div", _hoisted_41, [
          _createElementVNode("span", null, _toDisplayString($setup.result), 1)
        ]),
        _createElementVNode("div", _hoisted_42, [
          ($setup.resultstatus)
            ? (_openBlock(), _createBlock(_component_VanButton, {
                key: 0,
                block: "",
                round: "",
                color: "#33AC9C",
                style: {"width":"150px"},
                onClick: $setup.back
              }, {
                default: _withCtx(() => [
                  _hoisted_43
                ]),
                _: 1
              }))
            : (_openBlock(), _createBlock(_component_VanButton, {
                key: 1,
                block: "",
                plain: "",
                round: "",
                style: {"width":"150px"},
                onClick: $setup.back
              }, {
                default: _withCtx(() => [
                  _hoisted_44
                ]),
                _: 1
              }))
        ])
      ]),
      _: 1
    }, 8, ["show"])
  ]))
}